// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';
import momentTimezone from 'moment-timezone';
import {
  countries,
} from 'country-flag-icons';

// Types
type $Props = $Translate & {
  item: $Model<'Region'> | $ModelUpsertParams<'Region'>;
};

const RegionFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={6}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col xs={3}>
          <AvField
            label={t('Domain')}
            name={'Domain'}
            required
            value={item.Domain}
          />
        </Col>
        <Col xs={3}>
          <AvField
            label={t('Reg. letters')}
            name={'RegistrationLetters'}
            required
            value={item.RegistrationLetters}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <AvField
            label={t('Flag')}
            name={'Flag'}
            required
            type={'select'}
            value={item.Flag}
          >
            {_.map(
              countries,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {i}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col xs={8}>
          <AvField
            label={t('Timezone')}
            name={'Timezone'}
            required
            type={'select'}
            value={item.Timezone}
          >
            {item.Timezone === '' && (
              <option />
            )}
            {momentTimezone.tz.names().map((tz: string) => (
              <option
                key={tz}
                value={tz}
              >
                {tz}
              </option>
            ))}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <AvField
            label={t('Date format')}
            name={'DateFormat'}
            required
            value={item.DateFormat}
          />
        </Col>
        <Col xs={4}>
          <AvField
            label={t('Time format')}
            name={'TimeFormat'}
            required
            value={item.TimeFormat}
          />
        </Col>
        <Col xs={4}>
          <AvField
            label={t('Short format')}
            name={'ShortDateFormat'}
            required
            value={item.ShortDateFormat}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegionFieldsView;
